import { useMemo } from 'react';
import { HashUnit, convertHash } from '../utils';
import { abelAPI } from '../../api/abel';

const calculateRevenueBasedOnHashrate = (
  hashrate: number,
  hashrateUnit: HashUnit,
  avgBlockTime: number,
  avgNetworkHashrate: number,
  blockReward: number
) => {
  return (
    ((((24 * 60 * 60) / avgBlockTime) * blockReward) / convertHash(avgNetworkHashrate, hashrateUnit)) *
    hashrate
  ).toFixed(4);
};

const calculateRevenueUSDOnHashrate = (
  hashrate: number,
  hashrateUnit: HashUnit,
  avgBlockTime: number,
  avgNetworkHashrate: number,
  price: number,
  blockReward: number
) => {
  console.log(
    ((((24 * 60 * 60) / avgBlockTime) * blockReward) / convertHash(avgNetworkHashrate, hashrateUnit)) * hashrate * price
  );
  return (
    ((((24 * 60 * 60) / avgBlockTime) * blockReward) / convertHash(avgNetworkHashrate, hashrateUnit)) *
    hashrate *
    price
  ).toFixed(4);
};

export const useHashrateRevenueCalculator = (hashrates: number[], hashrateUnit: HashUnit, abelPrice: number) => {
  const {
    data: globalNetworkInfo,
    isLoading: globalNetworkInfoLoading,
    error: globalNetworkInfoError,
  } = abelAPI.hookWrapper.useSummaryInfo();

  return useMemo(() => {
    const result = {
      isLoading: globalNetworkInfoLoading,
      error: globalNetworkInfoError,
    };

    if (!globalNetworkInfo || globalNetworkInfoLoading || globalNetworkInfoError)
      return {
        ...result,
        data: [],
      };

    const blockReward = Math.floor(globalNetworkInfo.latestBlock?.totalfee);
    return {
      ...result,
      data: hashrates.map((hashrate) => {
        return {
          revenue: calculateRevenueBasedOnHashrate(
            hashrate,
            hashrateUnit,
            globalNetworkInfo.avgBlockTimeLast1k,
            globalNetworkInfo.networkHashRateLast1K,
            blockReward
          ),
          revenueUSD: calculateRevenueUSDOnHashrate(
            hashrate,
            hashrateUnit,
            globalNetworkInfo.avgBlockTimeLast1k,
            globalNetworkInfo.networkHashRateLast1K,
            abelPrice,
            blockReward
          ),
        };
      }),
    };
  }, [hashrates, hashrateUnit, globalNetworkInfo, globalNetworkInfoLoading, globalNetworkInfoError, abelPrice]);
};
